module.exports = __webpack_public_path__ + "static/media/28.85208d1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/28.png
// module id = 1134
// module chunks = 0